define(['jquery'], function ($) {
    var _defaults = {
        containerSelector: "#mobilePanel"
    };
    var _options = {};
    var _mobilePanel = {};
    var _internals = {
        init: function (options) {
            _options = $.extend({}, _defaults, options);
            var container = $(_options.containerSelector);

            _mobilePanel = {
                container: container,
                opened: false,
                current: {},
                path: [],
                oldParent: null
            };

            container.html('<div class="header"><a class="back hidden" href="#" data-back="true"></a><span></span>'
                + '<a class="close" data-action="close" href="#"></a></div><ul class="items"></ul>');

            $('[data-toggle="mobile-menu"]').each(function () {
                var toggle = $(this);
                toggle.on('click', _internals.menuNavigate);
            });

            container
                .on('click', '[data-action="close"]', _internals.closeMenu)
                .on('click', 'a.back', _internals.menuNavigate)
                .on('click', '.items > li > a', _internals.menuNavigate);

            $(window).resize(function () {
                if (_mobilePanel.opened) {
                    container.find('[data-action="close"]').trigger("click");
                }
            });

        },
        closeMenu: function (e) {
            e.preventDefault();
            var items = _mobilePanel.container.find('> .items');

            if (_mobilePanel.oldParent !== null) {
                var item = items.find(' > li > :first-child');
                item.appendTo(_mobilePanel.oldParent);
                _mobilePanel.oldParent = null;
            }

            _mobilePanel.container.removeClass('open');

            items.find('input').autocomplete("destroy");
            items.empty();
            _mobilePanel.path = [];
            _mobilePanel.current = null;
            _mobilePanel.opened = false;
        },
        menuNavigate: function (e) {
            var element = $(this);
            var data = element.data();
            if (data.text === undefined) {
                data.text = element.text();
            }

            if (!_mobilePanel.opened) {
                _mobilePanel.container.addClass('open');
                _mobilePanel.opened = true;
            }

            if (data.back) {
                if (_mobilePanel.path.length > 0) {
                    data = _mobilePanel.current = _mobilePanel.path.pop();
                }
            } else {
                _mobilePanel.path.push(_mobilePanel.current);
                _mobilePanel.current = data;
            }

            if ($(data.target).length) {
                e.preventDefault();

                var items = _mobilePanel.container.find('> .items');
                items.empty();

                $(data.target).find('[data-parent="' + data.target + '"]').each(function () {
                    var element = $(this);
                    var item = element.find('> a').clone();
                    if (element.find('ul').length) {
                        item.addClass('has-children');
                    }
                    $('<li/>').append(item).appendTo(items);
                });

                $(data.target).find('form').each(function () {
                    var element = $(this);
                    if (data.move === true) {
                        item = element;
                        _mobilePanel.oldParent = item.parent();
                    } else {
                        var item = element.clone();
                        item.id = "mobileForm";
                        item.removeClass();
                        _internals.initAutocomplete(item.find('input'));
                        item.find('input').first().focus();
                    }
                    $('<li/>').append(item).appendTo(items);
                });

                _mobilePanel.container.find('> .header > span').text(data.text);

                if (_mobilePanel.path.length > 1) {
                    _mobilePanel.container.find('a.back').removeClass('hidden');
                } else {
                    _mobilePanel.container.find('a.back').addClass('hidden');
                }
            }
        },
        initAutocomplete: function (selector) {
            require(['autocomplete'], function () {
                selector.autocomplete({
                    serviceUrl: '/api-services/product/search',
                    minChars: 3,
                    deferRequestBy: 200,
                    preventBadQueries: false,
                    triggerSelectOnValidInput: false,
                    onSelect: function (suggestion) {
                        window.location.href = suggestion.data;
                    },
                    formatResult: function (suggestion) {
                        return suggestion.view;
                    }
                });
            });
        }
    };

    return {
        init: function (options) {
            _internals.init(options);
        }
    };
});